<div class="zoom-redirect-container">
  <div class="content" *ngIf="isProcessing">
    <h2>{{ 'settings.integrations.zoom.template.redirectPageProcessingTitle' | translate }}</h2>
    <p>{{ 'settings.integrations.zoom.template.redirectPageProcessingMessage' | translate }}</p>
  </div>

  <div class="content error" *ngIf="error && !isProcessing">
    <mat-icon color="warn">error</mat-icon>
    <h2>{{ 'settings.integrations.zoom.template.redirectPageErrorTitle' | translate }}</h2>
    <p>{{ 'settings.integrations.zoom.template.redirectPageErrorMessage' | translate }}</p>
  </div>
</div>
